import React, { useContext, useState } from "react";
import { Form,  message } from "antd";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import SigninForm from "./SigninForm";
import { UserService } from "../../APIs";
import { AuthContext} from "../AuthContext/AuthContext";
import { useNotification } from "../Toast/Notification";
import { useCart } from "../CartContext/CartContext";
import cartServiceInstance from "../../APIs/cartItems";
import { UserData } from "../../@types/user";

const Signin = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isVerified, setIsVerified] = useState<boolean>(true);


  const navigate = useNavigate();
  const { login,  } = useContext(AuthContext);
  const { orderReference } = useCart();
  const { notify } = useNotification();

  const onFinish = async () => {
    setLoading(true);
    try {
      await form.validateFields();
      const existingUser = await UserService.getUserByEmailAddress(email);

      if (existingUser?.data && !existingUser.data.is_verified) {
        setIsVerified(false);
        notify(
          "Your account is not verified. Please check your email to verify your account.",
          "error"
        );
        return;
      }

      const response = await UserService.loginUser({ email, password });

      if (response.error) {
        notify("Login failed. Please check your email and password.", "error");
      } else if (response.data) {
        const loginData: UserData = response.data.user || null;
        
        if (loginData) {
          login(loginData);
          const userId = loginData.id;
          
          const redirectTo = localStorage.getItem("redirectAfterLogin") || "/";
          navigate(redirectTo);
          localStorage.removeItem("redirectAfterLogin");
          notify("Login successful!", "success");
  
        
          if (orderReference && userId) {
            const updateResponse = await cartServiceInstance.updateUserIdByOrderReference(
              orderReference,
              userId
            );

  
            if (updateResponse.data) {
              
            } else {
              console.error("Error updating user:", updateResponse.error);
            }
          }
        } else {
          notify("No user data returned. Please try again.", "error");
        }
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      message.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  

  const handleResendVerification = async () => {
  
    try {
      const { success, error } = await UserService.resendVerificationEmail(
        email
      );
      if (success) {
        notify("A new verification email has been sent!", "success");
      } else {
        notify(error || "Failed to resend verification email.", "error");
      }
    } catch (error) {
      console.error("Error resending verification email:", error);
      notify("An error occurred while resending the email.", "error");
    } finally {
     
    }
  };

  return (
    <>
      <Header
        title="Sign in to your account"
        textBackground="SIGN IN"
        desktopHeight="auto"
        backgroundImg="http://res.cloudinary.com/brabenjos/image/upload/v1729584914/sodastream/1729584914532.png"
        subTitle=""
      />

      <SigninForm
        email={email}
        password={password}
        onFinish={onFinish}
        setEmail={setEmail}
        setPassword={setPassword}
        loading={loading}
        handleResendVerification={handleResendVerification}
        isVerified = {isVerified}


      />

      
      <Footer />
    </>
  );
};

export default Signin;
